
/**
 * Integrazione con fecon-isac: espone metodi utilizzati da fecon-isac per effettaure la propria business-logic.
 *
 * @note Questo servizio è registrato come "delegato" di fecon-isac in app/app.config/isac.config.js
 */
export class ProductFeconIsacIntegrationDelegateService {

    constructor ($q, $log, AuthApiFactory) {
        'ngInject';

        this._logger = $log.getInstance('ProductFeconIsacIntegrationDelegateService');
        this._$q = $q;
        this.authApiFactory = AuthApiFactory;

        this._logger.log('instantiated');
    }


    /**
     * Deve determinare se il back-end del prodotto riconosce una sessione di lavoro valida. (tipicamente GET /product-api/session)
     * Nota: non sottoporre a cache: bisogna effettuare sempre la chiamata al proprio back-end di prodotto
     *
     * @param opts {{ additionalHeaders: { string: string} }} additionalHeaders: Object to merge with the $http request to bypass feconIsacSessionExpiredInterceptor
     * @returns Promise
     */
    asyncCheckProductAuthentication (opts) {
        this._logger.log('asyncCheckProductAuthentication(opts) opts:', opts);
        const additionalHeaders = opts.additionalHeaders || {};

        // TODO: implementare contattando il proprio back-end
        return this.authApiFactory.getStatus({ additionalHeaders });
        //return this._$q.resolve();
    }


    /**
     * Chiedere al back-end di prodotto di eliminare la sessione.
     * Nota:
     *  -> risolvere anche se il back-end non riconosce una sessione valida (tipicamente quando risponde 401 alla DELETE /product-api/session)
     *  -> rigettare solo se non è possibile contattare il back-end
     *
     * @param opts {{ additionalHeaders: { string: string} }} additionalHeaders: Object to merge with the $http request to bypass feconIsacSessionExpiredInterceptor
     * @returns Promise
     */
    asyncDestroyProductSession (opts) {
        this._logger.log('asyncDestroyProductSession(opts) opts:', opts);
        const additionalHeaders = opts.additionalHeaders || {};

        // TODO: implementare contattando il proprio back-end
        // es: return this.appAuthApiService.logout({ additionalHeaders });
        return this._$q.resolve();
    }


    /**
     * Invocare l'api del back-end di prodotto per effettuare l'invio di una mail contenente un token valido per la forzatura della password.
     *
     * @note Questo metodo è OPZIONALE:
     * Viene utilizzato solo se in feconIsacConfig è stato impostato 'credentialsRecovery.sendEmail.delegateApiCallToProductIntegration': true
     * @see app/app.config/isac.config.js
     *
     * @param opts {{ additionalHeaders: { string: string} }} additionalHeaders: Object to merge with the $http request to bypass feconIsacSessionExpiredInterceptor
     * @returns Promise
     */
    asyncExecuteSendEmailForCredentialsRecovery (opts) {
        this._logger.log('asyncExecuteSendEmailForCredentialsRecovery(opts) opts:', opts);
        const additionalHeaders = opts.additionalHeaders || {};

        // TODO: implementare contattando il proprio back-end
        // es: return this.appAuthApiService.sendEmailForCredentialsRecovery({ additionalHeaders });
        return this._$q.resolve();
    }


    /**
     * Una volta eseguito il logout con successo, fecon-isac computa automaticamente un url da usare per ricaricare completamente l'app.
     * Restituendo una stringa non-vuota, fecon-isac la utilizza come url di atterraggio desiderato.
     *
     * @note per manipolare il nuovo url utilizzare la libreria urijs già presente nelle dipendenze fecon. (import URI from 'urijs';)
     * @see https://medialize.github.io/URI.js/
     *
     * @returnn {string}
     */
    getTargetLogoutUrl () {}


    /**
     * Nome dello stato che mostra la pagina di login
     * @note valore tipico: "external.login" dove "external" è uno stato astratto che predisponde un layout pubblico (per componenti non autenticati)
     * @returns {string}
     */
    getLoginState () {
        // TODO: sostituire con lo stato reale    -- es: external.login
        return 'login';
    }


    /**
     * Nome dello stato cui andare ad autenticazione avvenuta
     * @note valore tipico: "main.<main-state>" dove "main" è lo stato astratto (previsto da FeCon) che predisponde un layout dedicato ai componenti autenticati
     * @returns {string}
     */
    getLoggedInState () {
        return 'main.init';
    }


    /**
     * Oggetto di personalizzazione previsto dal front-end Isac.
     * Con opts.flowName è possibile differenziare il flusso in esecuzione ('default', 'modalLoginFlow')
     *
     * @note le proprietà "language" e "redirect" vengono ignorate perché gestite internamente da fecon-isac.
     * @see isac-angular project documentation: wikis/isac-customization, wikis/internationalization
     *
     * @param opts  {{ funName, mode, flowName }}
     * @returns {Object} or null
     */
    getIsacCustomizationObject (opts) {
        let customizationObject = {};

        if (opts.flowName === 'modalLoginFlow') {
            // isac-angular per la fun 'login' prevede un titolo (o eventuale immagine);
            // Se usiamo la login nel flusso modale, avremo anche il titolo della modale
            // quindi, per uniformità, mantengo il solo titolo della modale e nascondo il titolo interno al componente isac
            customizationObject.loginForm = {
                title: false
            };
        }

        return customizationObject;
    }


}



// WEBPACK FOOTER //
// ./client/app/isac-integration/ProductFeconIsacIntegrationDelegate.service.js